import { useEffect, useState } from 'react';

import { StoresProvider } from '@/common/components/StoresProvider/StoresProvider';
import { GlobalAccessTarget } from '@/security/entities/GlobalAccessTarget';
import { useEntityAccessEventEmitter } from '@/security/services/EntityAccessEventEmitter';
import { AccessTargetType } from '@/security/types/AccessTarget';

import AccessModalContent from './AccessModalContent/AccessModalContent';
import { GlobalAccessModalStore } from './GlobalAccessModalStore';

interface AccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: AccessTargetType;
  targets: GlobalAccessTarget[];
  onSuccess?: () => void;
}

function GlobalAccessModal(props: AccessModalProps) {
  const { targets, type, isOpen, onClose, onSuccess } = props;

  const entityAccessEventEmitter = useEntityAccessEventEmitter();

  const [accessStore, setAccessStore] = useState<Nullable<GlobalAccessModalStore>>(null);

  useEffect(() => {
    setAccessStore(isOpen ? new GlobalAccessModalStore(targets, type, entityAccessEventEmitter) : null);
  }, [isOpen]);

  if (!accessStore) {
    return null;
  }

  return (
    <StoresProvider stores={{ accessStore }}>
      <AccessModalContent isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} />
    </StoresProvider>
  );
}

export default GlobalAccessModal;
